<template>
    <section class="coming-soon band-cream">
        <div class="coming-soon__inner">
            <span class="kicker">{{ copy.kicker }}</span>
            <h2 class="coming-soon__title">
                <span
                    class="coming-soon__sparkle"
                    aria-hidden="true"
                >✦</span>
                {{ title }}
            </h2>
            <div class="coming-soon__tags">
                <span
                    v-for="(tag, index) in copy.tags"
                    v-bind:key="tag"
                    class="coming-soon__tag"
                    :class="{ 'coming-soon__tag--dashed': index === copy.tags.length - 1 }"
                >{{ tag }}</span>
            </div>
            <router-link
                class="btn-pill btn-pill--ghost coming-soon__cta"
                to="/contact"
            >{{ copy.contact }}</router-link>
        </div>
    </section>
</template>

<script>
import { mapState } from 'pinia'
import { useStore } from '@/stores/index'
import { getFeaturesContent } from '@/data/features'

export default {
    name: 'ComingSoonSection',
    props: {
        title: String,
    },
    computed: {
        ...mapState(useStore, ['language']),
        copy() {
            return getFeaturesContent(this.language).comingSoon
        },
    },
}
</script>

<style lang="scss" scoped>
.coming-soon__inner {
    max-width: 640px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
}

.coming-soon__title {
    margin: 0;
    font-size: clamp(24px, 3.4vw, 34px);
}

.coming-soon__sparkle {
    display: inline-block;
    color: var(--bzioup-color-pink);
    animation: coming-soon-sparkle 2s ease-in-out infinite;
}

.coming-soon__tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
}

.coming-soon__tag {
    padding: 8px 16px;
    border-radius: 999px;
    font-size: 14px;
    font-weight: 600;
    background: var(--bzioup-bg-color-A);
    border: 1px solid rgba(218, 138, 139, 0.5);
    color: var(--bzioup-color-Z);
}

.coming-soon__tag--dashed {
    border-style: dashed;
    color: var(--bzioup-color-Y);
    background: transparent;
}

.coming-soon__cta {
    padding: 10px 20px;
    font-size: 14px;
}

@keyframes coming-soon-sparkle {
    0%, 100% { transform: rotate(0deg) scale(1); }
    50%      { transform: rotate(180deg) scale(1.2); }
}
</style>
